import axios from "axios"
import settings from "./settings"

const directaRechargeRequest = (
  payObId,
  promo_on_credits,
  price,
  paymentMethod,
  jsonBody
) => {
  const body = {
    accountId: payObId,
    promo_on_credits: promo_on_credits,
    price: price,
    currency: settings.CURRENCY,
    paymentMethod: paymentMethod,
    jsonBody,
  }
  console.log("Before send", body)
  return axios
    .post(settings.apiSettings.url + "/payments/makePayment/recharge", body)
    .then(response => {
      console.log("doPayment from server", response.status, response.data)

      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const payURechargeRequest = (
  payObId,
  promo_on_credits,
  price,
  paymentMethod
) => {
  const body = {
    accountId: payObId,
    promo_on_credits: promo_on_credits,
    price: price,
    currency: settings.CURRENCY,
    paymentMethod: paymentMethod,
  }
  console.log("Before send", body)
  return axios
    .post(settings.apiSettings.url + "/payments/makePayment/recharge", body)
    .then(response => {
      console.log("doPayment from server", response.status, response.data)

      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const payUPaymentRequest = (
  payObId,
  paymentPlanId,
  discount,
  amount,
  paymentMethod
) => {
  const body = {
    userId: payObId,
    planId: paymentPlanId,
    discount,
    amount,
    currency: settings.CURRENCY,
    paymentMethod,
  }
  console.log("Before send", body)
  return axios
    .post(settings.apiSettings.url + "/payments/makePayment", body)
    .then(response => {
      console.log("doPayment from server", response.status, response.data)

      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const directaPaymentRequest = (
  payObId,
  paymentPlanId,
  discount,
  amount,
  paymentMethod,
  jsonBody
) => {
  const body = {
    userId: payObId,
    planId: paymentPlanId,
    discount,
    amount,
    currency: settings.CURRENCY,
    paymentMethod,
    jsonBody,
  }
  console.log("Before send", body)
  return axios
    .post(settings.apiSettings.url + "/payments/makePayment", body)
    .then(response => {
      console.log("doPayment from server", response.status, response.data)

      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

export default {
  directaRechargeRequest,
  directaPaymentRequest,
  payUPaymentRequest,
  payURechargeRequest,
}
